module.exports = __webpack_public_path__ + "img/medici_smartbook.ef684e38.png";